
































import {
  defineComponent,
  PropType,
  computed,
} from '@vue/composition-api';
import NavBarCoffee from '@/components/nav-bar-coffee/index.vue';
import { LeftArrowOutline24 } from '@hb/coffee-icons';
import { styleRecordPxToVm } from '@/shared/utils/style-unit';
import { goBack } from '@/api/native/utils';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import router from '@/router';
import type { NavBarConfig } from '../../config/types';

export default defineComponent({
  name: 'NavBar',
  components: {
    NavBarCoffee,
    LeftArrowOutline24,
  },
  props: {
    config: {
      type: Object as PropType<NavBarConfig>,
      required: true,
    },
    titleIsCenter: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const onBack = () => {
      ubtSetupModuleExpose('finance_commonNavbar_pageExit', {
        currentPage: router.currentRoute.path,
      });

      goBack();
    };
    /** 中央标题自定义样式 */
    const slotTitleStyle = computed(() => styleRecordPxToVm(props.config.slotTitle?.style));
    /** 左侧返回按钮自定义样式 */
    const leftArrowStyle = computed(() => styleRecordPxToVm(props.config.slotLeftStyle));

    return {
      slotTitleStyle,
      leftArrowStyle,
      onBack,
    };
  },
});
